<form
  class="search-form"
  [formGroup]="formGroup"
  (ngSubmit)="onSubmit($event)"
  [hidden]="!!modelToEdit"
>
  <app-scroll-view class="scroll-view">
    <div class="filter-container">
      <div class="row gx-2">
        <div class="col-md-6">
          <div class="field-set">
            <label label> ESTADO DE OCORRÊNCIA </label>

            <app-select-box
              formControlName="status"
              [items]="statusList"
              displayExpr="description"
              valueExpr="id"
              [showErrorEnabled]="false"
              [appBlockModalDrag]="!(isMobileModeObservable | async)"
            ></app-select-box>
          </div>
        </div>

        <div class="col-md-6">
          <div class="field-set">
            <label label> ID SIIA </label>

            <app-input-box
              formControlName="idSiia"
              [showErrorEnabled]="false"
              [appBlockModalDrag]="!(isMobileModeObservable | async)"
            ></app-input-box>
          </div>
        </div>

        <div class="col-md-6">
          <div class="field-set">
            <label label> TIPO DE OCORRÊNCIA </label>

            <app-select-box
              formControlName="type"
              [items]="typeList"
              displayExpr="description"
              valueExpr="id"
              [showErrorEnabled]="false"
              [appBlockModalDrag]="!(isMobileModeObservable | async)"
            ></app-select-box>
          </div>
        </div>

        <div class="col-md-6">
          <div class="field-set">
            <label label> ENTIDADE CRIAÇÃO </label>

            <app-select-box
              formControlName="entityId"
              [items]="entityList"
              displayExpr="name"
              valueExpr="id"
              [showErrorEnabled]="false"
              [appBlockModalDrag]="!(isMobileModeObservable | async)"
            ></app-select-box>
          </div>
        </div>

        <div class="col-md-6">
          <div class="field-set">
            <label label> ENTIDADE NOTIFICADA </label>

            <app-select-box
              formControlName="entityIdNotified"
              [items]="entityList"
              displayExpr="name"
              valueExpr="id"
              [showErrorEnabled]="false"
              [appBlockModalDrag]="!(isMobileModeObservable | async)"
            ></app-select-box>
          </div>
        </div>

        <div class="col-md-6">
          <div class="row gx-2">
            <div class="col-md-6">
              <div class="field-set">
                <label label> DATA DE INÍCIO </label>

                <app-date-box
                  formControlName="startDate"
                  type="date"
                  [showClearButton]="false"
                  [showErrorEnabled]="false"
                  [appBlockModalDrag]="!(isMobileModeObservable | async)"
                ></app-date-box>
              </div>
            </div>

            <div class="col-md-6">
              <div class="field-set">
                <label label> DATA DE FIM </label>

                <app-date-box
                  formControlName="endDate"
                  type="date"
                  [showClearButton]="false"
                  [showErrorEnabled]="false"
                  [appBlockModalDrag]="!(isMobileModeObservable | async)"
                ></app-date-box>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="result-list-container" #resultListContentEl>
      <label> RESULTADO DA PESQUISA </label>

      <app-list class="list" [items]="resultList" [scrollable]="false">
        <ng-template listItem let-item="item">
          <div
            class="item"
            [appBlockModalDrag]="!(isMobileModeObservable | async)"
          >
            <div class="actions">
              <div class="btn-item" #btnZoomToEl>
                <app-button
                  [buttonType]="
                    modelZoomToSelected === item ? 'primary' : 'normal'
                  "
                  styleType="text"
                  shapeType="circle"
                  icon="assets/icons/location-arrow.svg"
                  (click)="onBtnZoomToClick(item)"
                  [disabled]="!item.geometry"
                ></app-button>

                <app-tooltip
                  [target]="btnZoomToEl"
                  verticalAlignment="top"
                  horizontalAlignment="center"
                >
                  Ver no mapa
                </app-tooltip>
              </div>

              <div class="btn-item" #btnEditEl>
                <app-button
                  buttonType="normal"
                  styleType="text"
                  shapeType="circle"
                  icon="assets/icons/pen.svg"
                  (click)="onEditClick(item)"
                ></app-button>

                <app-tooltip
                  [target]="btnEditEl"
                  verticalAlignment="top"
                  horizontalAlignment="center"
                >
                  Editar
                </app-tooltip>
              </div>
            </div>

            <div class="title">
              {{ item.idsic }} - Data da ocorrência:
              {{ item.createdAt | date : "dd/MM/yyyy" }}
            </div>
          </div>
        </ng-template>
      </app-list>

      <div class="pagination-container">
        <app-pagination
          [totalCount]="totalCount"
          [pageSize]="pageSize"
          [pageIndex]="pageIndex"
          (pageIndexChange)="onPageChange($event)"
          [appBlockModalDrag]="!(isMobileModeObservable | async)"
        ></app-pagination>
      </div>

      <app-loading-panel
        [visible]="loadingController.changes | async"
        [container]="resultListContentEl"
        [overlayMask]="false"
      ></app-loading-panel>
    </div>
  </app-scroll-view>

  <div class="actions-bottom">
    <div
      class="btn-item"
      [appBlockModalDrag]="!(isMobileModeObservable | async)"
    >
      <app-button
        type="submit"
        buttonType="primary"
        styleType="contained"
        text="PESQUISAR OCORRÊNCIA"
        width="20rem"
        [disabled]="formGroup.invalid"
      ></app-button>
    </div>
  </div>
</form>

<div class="edit-container" *ngIf="!!modelToEdit">
  <app-toolbar class="toolbar">
    <div
      #btnGoBackEl
      appToolbarItemBefore
      class="btn-go-back-item"
      [appBlockModalDrag]="!(isMobileModeObservable | async)"
    >
      <app-button
        buttonType="normal"
        styleType="text"
        shapeType="circle"
        icon="assets/icons/chevron-left.svg"
        marginType="icon"
        (click)="onBtnGoBackClick()"
      ></app-button>

      <app-tooltip
        [target]="btnGoBackEl"
        verticalAlignment="top"
        horizontalAlignment="center"
      >
        Voltar
      </app-tooltip>
    </div>

    <div appToolbarItemBefore class="title">Editar ocorrência</div>
  </app-toolbar>

  <app-occurrence-register
    [model]="modelToEdit"
    [mapView]="mapView"
    [mainMapImageLayer]="mainMapImageLayer"
    [groupLayer]="editGroupLayer"
    (onSaved)="onOccurenceSaved($event)"
  ></app-occurrence-register>
</div>
